import React from "react";
import styled from "styled-components";
import InfiniteScroll from "react-infinite-scroll-component";
import { useArtistsQuery } from "../../queries/artists.query";
import PageLoader from "../../common/components/PageLoader/PageLoader";
import ArtistCard from "../../common/components/ArtistCard/ArtistCard";
import Typography from "../../common/components/Typography/Typography";
import InfinityListLoader from "../../common/components/InfinityListLoader/InfinityListLoader";
import FetchDataError from "../../common/components/FetchDataError/FetchDataError";
import { getPagesItems } from "../../helpers/paginationHelper";

const Container = styled.div`
  padding: 64px 20px 128px 20px;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    padding: 40px 20px 52px 20px;
  }
`;

const ArtistsContainer = styled.div`
  margin-top: 64px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: auto auto;
  column-gap: 24px;
  row-gap: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const Artists = () => {
  const {
    data: artistsPages,
    isLoading,
    isFetchingNextPage,
    isError,
    hasNextPage,
    fetchNextPage,
  } = useArtistsQuery();
  const artistsItems = getPagesItems(artistsPages?.pages);

  if (isLoading && !isFetchingNextPage) {
    return <PageLoader instant />;
  }

  if (isError) {
    return <FetchDataError />;
  }

  return (
    <Container className="main-container">
      <Typography heading id={"artists-explore"} weight="500" />
      <InfiniteScroll
        next={() => fetchNextPage()}
        hasMore={!!hasNextPage}
        loader={<InfinityListLoader />}
        dataLength={artistsItems.length}
      >
        <ArtistsContainer>
          {artistsItems.map((artist) => (
            <ArtistCard key={artist.id} artist={artist} />
          ))}
        </ArtistsContainer>
      </InfiniteScroll>
    </Container>
  );
};

export default Artists;
